import type { SnapshotGridField } from "@/modules/snapshots/businessReports.api";

const SYSTEM_FIELD_KEYS: Record<string, string> = {
  id: "system:id",
  name: "system:name",
  status: "system:status",
  created_at: "system:created_at",
  verified: "system:verified",
};

export const snapshotGridColumnKey = (nameOrKey: string, fields: SnapshotGridField[]): string | null => {
  if (/^(prompt|note|system):/.test(nameOrKey)) return nameOrKey;
  if (SYSTEM_FIELD_KEYS[nameOrKey]) return SYSTEM_FIELD_KEYS[nameOrKey];
  const matches = fields.filter(field => field.name === nameOrKey);
  return matches.length === 1 ? matches[0].key : null;
};

export const snapshotGridColumnName = (key: string, fields: SnapshotGridField[]): string | null => {
  const systemName = Object.entries(SYSTEM_FIELD_KEYS).find(([, value]) => value === key)?.[0];
  if (systemName) return systemName;
  return fields.find(field => field.key === key)?.name ?? null;
};
